import { Alert, Button, Card, Checkbox, Col, Divider, Dropdown, Form, Icon, Input, InputNumber, Menu, message, Row, Select, Spin, Switch, AutoComplete } from "antd";
import axios from "axios";
import { GoogleApiWrapper, Map } from "google-maps-react";
import fileDownload from "js-file-download";
import * as React from "react";
import { AssortmentPageTable } from "../../components/AssortmentPageTable";
import { LabaledField } from "../../components/LabeledField";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { PageContent } from "../../components/PageContent";
import { getPriceByDistance } from "../../constants/distance-expenses";
import { Helpers } from "../../utils/helpers";
import { Assortment } from "../AcceptancePointAssortment/create";

export interface AssortmentPageAssortment extends Assortment {
    show: boolean;
    category: string;
}

interface CreateFellingPointsState {
    fellingAreas: any[];
    assortmentIsLoaded: boolean;
    totalRecords: number;
    currentPage: number;
    searchKeyword: string;
    assortment: null | AssortmentPageAssortment[];
    pointAddress: string | null;
    onlyChecked: boolean;
    acceptancePointsLoaded: boolean;
    acceptancePoints: null | AcceptancePointAssortmentPageV2[];
    pointLat: null | number;
    pointLng: null | number;
    distanceFilter: number[];
    fetchingAssortmentData: boolean;
    firstFetchingAssortmentData: boolean;
    assortmentLimitPerDiameter: number;
    highlightHighestPrice: boolean;
    filters: AssortmentFilters[];
    filterFields: FilterFields;
    bonuses: BonusesFields;
    allRowsChecked: boolean;
}

export interface BonusesFields {
    // bonus: boolean;
    // fsc_bonus: boolean;
    // fsc_100_bonus: boolean;
    surface_coefficient: boolean;
    acceptance_point_bonus: boolean;
}

export interface FilterFields {
    sawCost: number;
    importCost: number;
    transportCost: boolean;
}

export interface AcceptancePointAssortmentPageV2 {
    distanceLoading: boolean;
    distance: number;
    duration: number;
    price: number;
    transportExpenses: number;
    transportExpensesPerCubicMeter: number;
    kind: string;
    diameters: AcceptancePointAssortmentPageV2Diameters[];
    show: boolean;
}

export interface AcceptancePointAssortmentPageV2Diameters {
    min: number;
    max: number;
    lengths: AcceptancePointAssortmentPageV2Lengths[];
}

export interface AcceptancePointAssortmentPageV2Lengths {
    length: number;
    price: number;
    assortment_id: number;
    surface_coefficient: number;
    acceptance_point_bonus: number;
    category: string;
    id: number;
    name: string;
    address: string;
    plan: number;
    assortment_bonus: number;
    lat: number;
    assortmentCode: string;
    updated_at: string;
    calculationError: boolean;
    hash: string;
    checked: boolean;
    comment?: string;
    transportExpensesPerCubicMeter: number;
    calculatedPrice: number;
}

interface CreateFellingPointsStateProps {
    form: any;
    map: any;
    google: any;
    ruleIsValid(ruleId: any): boolean;
}

interface AssortmentFilters {
    title: string;
    code: string;
    show: boolean;
}

const filters: AssortmentFilters[] = [{
    title: "Egle (E zb, E pm, Gulsnis, SK tara, SK malka)",
    code: "egle",
    show: false,
}, {
    title: "Priede (P zb, P pm, Gulsnis, SK tara, SK malka)",
    code: "priede",
    show: false,
}, {
    title: "Apse (A pm, malka, tara, zb, zb II klase, LK tara, LK malka)",
    code: "apse",
    show: false,
}, {
    title: "Bērzs (B pm, tara, fin. A, fin. B, fin. C LK tara, LK malka)",
    code: "berzs",
    show: false,
}, {
    title: "Baltalksnis (AL pm, LK tara, LK malka)",
    code: "baltalksnis",
    show: false,
}, {
    title: "Melnalksnins (MAL II klase, LK tara, LK malka)",
    code: "melnalksnis",
    show: false,
}, {
    title: "Ozols (O, LK tara, LK malka)",
    code: "ozols",
    show: false,
}, {
    title: "Osis (OS, LK tara, LK malka)",
    code: "osis",
    show: false,
}];

class AssortmentPageWrapped extends React.Component<CreateFellingPointsStateProps, CreateFellingPointsState> {
    map;
    searchInput;

    constructor(props) {
        super(props);

        this.state = {
            fellingAreas: [],
            assortment: null,
            assortmentIsLoaded: false,
            pointAddress: null,
            pointLat: null,
            pointLng: null,
            onlyChecked: false,
            highlightHighestPrice: false,
            // Search
            searchKeyword: "",
            // Pagination
            totalRecords: 0,
            currentPage: 1,
            // Acceptance points
            acceptancePointsLoaded: false,
            acceptancePoints: null,
            // Filters
            distanceFilter: [0, 200],
            fetchingAssortmentData: false,
            assortmentLimitPerDiameter: 5,

            firstFetchingAssortmentData: true,

            bonuses: {
                // bonus: false,
                // fsc_bonus: false,
                // fsc_100_bonus: false,
                surface_coefficient: false,
                acceptance_point_bonus: false,
            },

            filters,
            filterFields: {
                sawCost: 0,
                importCost: 0,
                transportCost: false,
            },

            allRowsChecked: false
        };
    }

    componentDidMount() {
        this.fetchAssortment();
        document.title = "Dižozols - Sortimentu Lapa";
    }

    componentDidUpdate(prevProps, prevState) {
        // Hide map if close modal
        if (this.props !== prevProps.map && this.state.pointAddress !== prevState.pointAddress) {
            // If state changed - render new map
            this.renderAddressInMap();
        }
    }

    fetchAssortment = () => axios.get(`${process.env.baseUrl}/assortment`)
        .then(response => {
            if (response.data.success === false) {
                message.error("Neizdevās ielādēt sortimentus");
            }

            this.setState({
                assortment: response.data.data.map(assortmentItem => ({
                    ...assortmentItem,
                    show: false,
                })),
                assortmentIsLoaded: true,
            });
        }).catch(_error => {
            message.error("Neizdevās ielādēt sortimentu sarakstu");
        })

    fetchAcceptancePointAssortment = () => this.setState({
            fetchingAssortmentData: true,
        }, () => {
            axios.post(`${process.env.baseUrl}/acceptance_points/assortment/page_data`, {
                pointLat: this.state.pointLat,
                pointLng: this.state.pointLng,
            })
            .then(response => {
                if (response.data.success === false) {
                    return message.error("Neizdevās ielādēt sortimentus");
                }

                return this.setState({
                    fetchingAssortmentData: false,
                    firstFetchingAssortmentData: false,
                    acceptancePoints: response.data.data.map(acceptancePoint => ({
                        ...acceptancePoint,
                        show: this.showAssortment(acceptancePoint.kind),
                    })),
                });
            })
            .catch(_error => {
                message.error("Neizdevās ielādēt pieņemšanas punktus");
            });
        })

    showAssortment = (code) => {
        const filter = this.state.filters.find(assortmentItem => assortmentItem.code === code);

        if (!filter) {
            return false;
        }

        return filter.show;
    }

    checkPoint = (checked: boolean, hash: string) => {
        const acceptancePointsTemp = [...this.state.acceptancePoints!];
        const filteredList = acceptancePointsTemp.map(group1 => ({
            ...group1,
            diameters: group1.diameters.map(group2 => ({
                ...group2,
                lengths: group2.lengths.map(group3 => ({
                    ...group3,
                    checked: (group3.hash === hash) ? checked : group3.checked,
                })),
            })),
        }));

        this.setState({ acceptancePoints: filteredList });
    }

    findLengthElementIndex = (hash) => {
        let firstLevelIndex: any = null;
        let secondLevelIndex: any = null;
        let thirdLevelIndex: any = null;

        this.state.acceptancePoints!.forEach((element, firstIndex) => {
            element.diameters.forEach((element2, secondIndex) => {
                element2.lengths.forEach((element3, thirdIndex) => {
                    if (element3.hash === hash) {
                        firstLevelIndex = firstIndex;
                        secondLevelIndex = secondIndex;
                        thirdLevelIndex = thirdIndex;
                    }
                });
            });
        });

        if (firstLevelIndex === null && secondLevelIndex === null && thirdLevelIndex === null) {
            return null;
        }

        return [firstLevelIndex, secondLevelIndex, thirdLevelIndex];
    }

    renderAddressInMap = () => {
        const { google } = this.props;
        const mapReference = this.map;

        if (!google || !mapReference || !this.state.pointAddress) { return; }
        // Some new prototypes to make life easier
        google.maps.Map.prototype.markers = new Array();
        google.maps.Map.prototype.addMarker = function(marker) {
            this.markers[this.markers.length] = marker;
        };
        google.maps.Map.prototype.getMarkers = function() {
            return this.markers;
        };
        google.maps.Map.prototype.clearMarkers = function() {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
            this.markers = new Array();
        };

        const map = mapReference.map;
        const geocoder = new google.maps.Geocoder();
        // Trying to get location based on entered address
        geocoder.geocode({ address: this.state.pointAddress }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                // Remove old markers
                map.clearMarkers();
                // Set map center to new location
                map.setCenter(results[0].geometry.location);
                // Add new marker
                const marker = new google.maps.Marker({
                    map,
                    position: results[0].geometry.location,
                    draggable: true,
                });

                google.maps.event.addListener(marker, "dragend", () => {
                    this.setState({
                        pointLat: marker.getPosition().lat(),
                        pointLng: marker.getPosition().lng(),
                    }, () => {
                        this.fetchAcceptancePointAssortment();
                    });
                });

                map.addMarker(marker);

                this.setState({
                    pointLat: results[0].geometry.location.lat(),
                    pointLng: results[0].geometry.location.lng(),
                }, () => {
                    this.fetchAcceptancePointAssortment();
                });
            }
        });
    }

    setMapRef = (ref) => this.map = ref;

    onBonusesChange = (checked, bonusName) => {
        const objectField = {};
        objectField[bonusName] = checked;

        const newBonusesState = {
            ...this.state.bonuses,
            ...objectField,
        };

        this.setState({ bonuses: newBonusesState });
    }

    onHighlightHighestPriceChange = (checked) => {
        this.setState({ highlightHighestPrice: checked });
    }

    onOnlyCheckedChange = (checked) => {
        this.setState({ onlyChecked: checked });
    }

    toggleAssortment = (code) => {
        let tempAssortment: any = null;
        const tempFilters = [...this.state.filters];
        const filterIndex = tempFilters.findIndex(assortmentItem => assortmentItem.code === code);
        tempFilters[filterIndex].show = !tempFilters[filterIndex].show;

        if (this.state.acceptancePoints) {
            tempAssortment = [...this.state.acceptancePoints];
            const assortmentIndex = tempAssortment.findIndex(assortmentItem => assortmentItem.kind === code);
            tempAssortment[assortmentIndex].show = !tempAssortment[assortmentIndex].show;
        }

        this.setState({ filters: tempFilters, acceptancePoints: tempAssortment });
    }

    toggleAllAssortment = (selectAll) => {
        let tempAssortment: any = null;
        const tempFilters = [...this.state.filters];
        tempFilters.forEach(filter => filter.show = selectAll);
        if (this.state.acceptancePoints) {
            tempAssortment = [...this.state.acceptancePoints];
            tempAssortment.forEach(assortment => {
                assortment.show = selectAll;
            })
        }
        this.setState({ filters: tempFilters, acceptancePoints: tempAssortment });
    }

    formatter = (value) => {
        if (value === 200) {
            return `> ${value} km`;
        }

        return `${value} km`;
    }

    checkCommentObject = (length, commentId, hash) => {
        if (length.hash !== hash) {
            return {};
        }

        return { comment: commentId };
    }

    changeComment = (commentId, hash) => {
        if (this.state.acceptancePoints) {
            const temp = [...this.state.acceptancePoints];
            const withComment = temp.map(groups => ({
                ...groups,
                diameters: groups.diameters.map(diameter => ({
                    ...diameter,
                    lengths: diameter.lengths.map(length => ({
                        ...length,
                        ...this.checkCommentObject(length, commentId, hash),
                    })),
                })),
            }));

            this.setState({ acceptancePoints: withComment });
        }
    }

    handleDistanceChange = (value) => this.setState({ distanceFilter: value });

    changeAssortmentLimit = (value) => this.setState({ assortmentLimitPerDiameter: value });

    changeFilterField = (value, type) => {
        const objectField = {};
        objectField[type] = value;

        const newFiltersState = {
            ...this.state.filterFields,
            ...objectField,
        };

        this.setState({ filterFields: newFiltersState });
    }

    getExportData = () => {
        const exportMessage = message.loading("Sagatavo dokumentu...", 0);

        axios({
            url: `${process.env.baseUrl}/api/assortment_page/export/doc`,
            method: "POST",
            responseType: "blob",
            data: this.getTransformedData(),
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        }).then(response => {
            fileDownload(response.data, "sortimentu_lapa.docx");
            exportMessage();
        });
    }

    exportExcel = () => {
        const exportMessage = message.loading("Sagatavo dokumentu...", 0);

        axios({
            url: `${process.env.baseUrl}/api/assortment_page/export/xlsx`,
            method: "POST",
            responseType: "blob",
            data: this.getTransformedData(),
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        }).then(response => {
            fileDownload(response.data, "sortimentu_lapa.xlsx");
            exportMessage();
        });
    }

    calculatePrice = (object) => {
        const basePrice = object.price - getPriceByDistance(object.distance);
        let highestBonus = 0;
        let surfaceCoefficient = 0;
        let acceptancePointBonus = 0;

        if (this.state.bonuses.surface_coefficient && object.surface_coefficient) {
            surfaceCoefficient = object.surface_coefficient;
        }

        if (this.state.bonuses.acceptance_point_bonus && object.acceptance_point_bonus) {
            acceptancePointBonus = object.acceptance_point_bonus;
        }

        const withAssortmentBonuses = basePrice + highestBonus;
        // tslint:disable-next-line:binary-expression-operand-order
        let finalPrice = (1 + (surfaceCoefficient / 100)) * (withAssortmentBonuses * (1 + (acceptancePointBonus / 100)));

        if (this.state.filterFields.importCost) {
            finalPrice -= this.state.filterFields.importCost;
        }

        if (this.state.filterFields.sawCost) {
            finalPrice -= this.state.filterFields.sawCost;
        }

        return +(finalPrice).toFixed(2);
    }

    getTransformedData = (): AcceptancePointAssortmentPageV2[] => {
        if (this.state.acceptancePoints) {
            let acceptancePointsFilteredByMaxAmount;

            const calculatedPrices = this.state.acceptancePoints.reduce((kind, currentKind) => {
                kind.push({
                    ...currentKind,
                    diameters: currentKind.diameters.reduce((diameters, diameter) => {
                        diameters.push({
                            ...diameter,
                            lengths: diameter.lengths.reduce((lengths, length) => {
                                lengths.push({
                                    ...length,
                                    calculatedPrice: this.calculatePrice(length),
                                });

                                return lengths;
                            }, [] as AcceptancePointAssortmentPageV2Lengths[]).sort((a, b) => b.price - a.price),
                        });

                        return diameters;
                    }, [] as AcceptancePointAssortmentPageV2Diameters[]),
                });

                return kind;
            }, [] as AcceptancePointAssortmentPageV2[]);

            if (this.state.onlyChecked) {
                acceptancePointsFilteredByMaxAmount = calculatedPrices.map(acceptancePoint => ({
                    ...acceptancePoint,
                    diameters: acceptancePoint.diameters.map(pointDiameters => ({
                        ...pointDiameters,
                        lengths: pointDiameters.lengths.filter(length => length.checked),
                    })).filter(diameterFilter => diameterFilter.lengths.length > 0),
                })).filter(value => value.diameters.length > 0) as AcceptancePointAssortmentPageV2[];
            } else {
                acceptancePointsFilteredByMaxAmount = calculatedPrices.map(acceptancePoint => {
                    if (!acceptancePoint.show) {
                        return {};
                    }

                    return {
                        ...acceptancePoint,
                        diameters: acceptancePoint.diameters.map(pointDiameters => ({
                            ...pointDiameters,
                            lengths: pointDiameters.lengths.slice(0, this.state.assortmentLimitPerDiameter),
                        })),
                    };
                }).filter(value => Object.keys(value).length !== 0) as AcceptancePointAssortmentPageV2[];
            }

            return acceptancePointsFilteredByMaxAmount;
        }

        return null;
    }

    onAllRowsChecked(allChecked: boolean): void{
        const acceptancePointsCurrentlyShown = this.getTransformedData().reduce((prev, current) => {
            return prev.concat(current.diameters.reduce((prev, current) => {
                return prev.concat(current.lengths)
            }, []));
        }, []) as AcceptancePointAssortmentPageV2Lengths[];
        const tempAcceptancePoints = [...this.state.acceptancePoints!]

        const filteredList = tempAcceptancePoints.map(group1 => ({
            ...group1,
            diameters: group1.diameters.map(group2 => ({
                ...group2,
                lengths: group2.lengths.map(group3 => ({
                    ...group3,
                    /* if checked all and it is visible, mark as checked */
                    /* if not checked all or not visible, mark as not checked */
                    checked: allChecked && !!acceptancePointsCurrentlyShown.find(acceptancePoint => acceptancePoint.hash === group3.hash),
                })),
            })),
        }));

        this.setState({ 
            acceptancePoints: filteredList, 
            allRowsChecked: allChecked 
        });
    }


    render() {
        const pageContentProps = {
            headerTitle: "Sortimentu Lapa",
            fullPage: true,
            showHeader: true,
        };

        const mapWrapperStyle: any = {
            width: "100%",
            height: 250,
            position: "relative",
            marginTop: 5,
        };

        const exportMenu = (
            <Menu>
                <Menu.Item key="word">
                    <span onClick={() => this.getExportData()}><Icon type="file-word"/> MS Word</span>
                </Menu.Item>
                <Menu.Item key="excel">
                    <span onClick={() => this.exportExcel()}><Icon type="file-excel"/> MS Excel</span>
                </Menu.Item>
            </Menu>
        );

        const titleStyle = {
            fontWeight: 400,
            margin: 0,
            marginBottom: 3,
        } as any;

        return (
            <div>
                <PageContent {...pageContentProps}>
                    <Form>
                        <Row>
                            <Col span={6}>
                                <Card>
                                    <Row>
                                        {this.props.ruleIsValid("AssortmentPage:PricePageAllowSearch") && <div>
                                        <h4 style={titleStyle}>Cirsmas atrašanās vieta</h4>
                                            <Input
                                                allowClear={true}
                                                onPressEnter={(e) => this.setState({ pointAddress: e.target.value })}
                                                onBlur={(e) => this.setState({ pointAddress: e.target.value })}
                                            />
                                        </div>}

                                        <div style={mapWrapperStyle}>
                                            <Map
                                                ref={this.setMapRef}
                                                google={this.props.google}
                                                zoom={13}
                                                initialCenter={{
                                                    lat: 56.946285,
                                                    lng: 24.105078,
                                                }}
                                            />
                                        </div>
                                    </Row>
                                    <Row>
                                        <Row style={{ marginBottom: 15, marginTop: 25 }}>
                                            <LabaledField title="Sortimentu saraksts" nextLine={false}>
                                                <Switch
                                                    defaultChecked={false}
                                                    onChange={(e) => this.toggleAllAssortment(e)}
                                                />
                                            </LabaledField>
                                            <LabaledField nextLine={true}>
                                                {this.state.filters.map(filterValue => (
                                                    <Row key={filterValue.code} style={{ marginBottom: 5 }}>
                                                        <Checkbox
                                                            onChange={(_show) => this.toggleAssortment(filterValue.code)}
                                                            checked={filterValue.show}
                                                        >
                                                            {filterValue.title}
                                                        </Checkbox>
                                                    </Row>
                                                ))}
                                            </LabaledField>
                                        </Row>

                                        <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Sortimentu daudzums" description="Parādīt konkrētu daudzumu ar sortimentiem" large={true}>
                                                <InputNumber value={this.state.assortmentLimitPerDiameter} onChange={this.changeAssortmentLimit} min={1} max={20}/>
                                            </LabaledField>
                                        </Row>


                                        {this.props.ruleIsValid("AssortmentPage:AllowAcceptancePointBonus") && <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Pieņemšanas punkta piemaksa" description="Iekļaut pieņemšanas punkta piemaksu pie cenu aprēķiniem">
                                                <Switch
                                                    checkedChildren={<Icon type="check"/>}
                                                    unCheckedChildren={<Icon type="cross"/>}
                                                    defaultChecked={this.state.bonuses.acceptance_point_bonus}
                                                    onChange={(checked) => this.onBonusesChange(checked, "acceptance_point_bonus")}
                                                />
                                            </LabaledField>
                                        </Row>}

                                        {this.props.ruleIsValid("AssortmentPage:AllowCoefficient") && <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Uzmērījuma koeficients" description="Iekļaut uzmērījuma koeficientu pie cenu aprēķiniem">
                                                <Switch
                                                    checkedChildren={<Icon type="check"/>}
                                                    unCheckedChildren={<Icon type="cross"/>}
                                                    defaultChecked={this.state.bonuses.surface_coefficient}
                                                    onChange={(checked) => this.onBonusesChange(checked, "surface_coefficient")}
                                                />
                                            </LabaledField>
                                        </Row>}

                                        {this.props.ruleIsValid("AssortmentPage:ShowTransportExpenses") && <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Transporta izmaksas" description="Parādīt transporta izmaksas katram punktam">
                                                <Switch
                                                    checkedChildren={<Icon type="check"/>}
                                                    unCheckedChildren={<Icon type="cross"/>}
                                                    defaultChecked={this.state.filterFields.transportCost}
                                                    onChange={(value) => this.changeFilterField(value, "transportCost")}
                                                />
                                            </LabaledField>
                                        </Row>}

                                        {this.props.ruleIsValid("AssortmentPage:ExtraPriceAllow") && <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Zāģēšanas izmaksas (€)" description="Summa, kura tiks noņemta no kopējās summas" large={true}>
                                                <InputNumber value={this.state.filterFields.sawCost} onChange={(value) => this.changeFilterField(value, "sawCost")} min={0} max={9999}/>
                                            </LabaledField>
                                        </Row>}

                                        {this.props.ruleIsValid("AssortmentPage:ExtraPriceAllow") && <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Ievešanas izmaksas (€)" description="Summa, kura tiks noņemta no kopējās summas" large={true}>
                                                <InputNumber value={this.state.filterFields.importCost} onChange={(value) => this.changeFilterField(value, "importCost")} min={0} max={9999}/>
                                            </LabaledField>
                                        </Row>}

                                         {this.props.ruleIsValid("AssortmentPage:HighlightHighestPrice") &&  <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Izcelt augstāko cenu" description="Vizuāli izcel augstāko cenu no katras diametru grupas">
                                                <Switch
                                                    checkedChildren={<Icon type="check"/>}
                                                    unCheckedChildren={<Icon type="cross"/>}
                                                    defaultChecked={this.state.highlightHighestPrice}
                                                    onChange={this.onHighlightHighestPriceChange}
                                                />
                                            </LabaledField>
                                        </Row>}

                                        {this.props.ruleIsValid("AssortmentPage:ShowOnlyChecked") && <Row style={{ marginBottom: 15 }}>
                                            <LabaledField title="Rādīt tikai atzīmētos" description="Parādīt sarakstu tikai ar atzīmētajām cenām">
                                                <Switch
                                                    checkedChildren={<Icon type="check"/>}
                                                    unCheckedChildren={<Icon type="cross"/>}
                                                    defaultChecked={this.state.onlyChecked}
                                                    onChange={this.onOnlyCheckedChange}
                                                />
                                            </LabaledField>
                                        </Row>}
                                    </Row>
                                </Card>
                            </Col>

                            <Col span={17} offset={1}>
                                {this.state.onlyChecked && <div style={{ marginBottom: 10, textAlign: "right" }}>
                                    <Dropdown overlay={exportMenu}>
                                        <Button type="primary" style={{ marginLeft: 5 }}>
                                            <Icon type="export"/> Eksportēt
                                        </Button>
                                    </Dropdown>
                                </div>}

                                {this.state.assortmentIsLoaded &&
                                this.state.assortment &&
                                this.state.acceptancePoints ?
                                    <Spin spinning={this.state.fetchingAssortmentData} tip="Lūdzu uzgaidiet...">
                                        <AssortmentPageTable
                                            acceptancePoints={this.getTransformedData()}
                                            bonuses={this.state.bonuses}
                                            distanceFilter={this.state.distanceFilter}
                                            assortmentLimitPerDiameter={this.state.assortmentLimitPerDiameter}
                                            highlightHighestPrice={this.state.highlightHighestPrice}
                                            checkPoint={this.checkPoint}
                                            showOnlyChecked={this.state.onlyChecked}
                                            changeComment={this.changeComment}
                                            filterFields={this.state.filterFields}
                                            ruleIsValid={this.props.ruleIsValid}
                                            allChecked={this.state.allRowsChecked}

                                            onAllChecked={this.onAllRowsChecked.bind(this)}
                                        />
                                    </Spin>
                                : this.state.firstFetchingAssortmentData && this.state.fetchingAssortmentData ? <LoadingIndicator loadingText={true}/>
                                : <Alert message="Lūdzu norādiet cirsmas atrašanās vietu!" type="warning" showIcon/>}
                            </Col>
                        </Row>
                    </Form>
                </PageContent>
            </div>
        );
    }
}

const AssortmentPage = Form.create()(AssortmentPageWrapped as any);
// tslint:disable-next-line:no-default-export
export default GoogleApiWrapper({
    apiKey: process.env.CLIENT_GOOGLE_MAPS_API_KEY,
    LoadingContainer: (_props) => (
        <div></div>
    ),
})(AssortmentPage);
